var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOpinion = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 17,
  viewBox: "0 0 19 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3186 13.6L9.5 17L7.68211 13.6H0V0H19V13.6H11.3186Z",
  fill: "#999999"
}))));
export default SvgIconOpinion;